export enum ExchangeTransactionActionType {
  SELECT_EXCHANGE_TYPE = 'SELECT_EXCHANGE_TYPE',

  DESELECT_EXCHANGE_FROM_FUND = 'DESELECT_EXCHANGE_FROM_FUND',
  SELECT_EXCHANGE_FROM_FUND = 'SELECT_EXCHANGE_FROM_FUND',
  UPDATE_EXCHANGE_FROM_FUND = 'UPDATE_EXCHANGE_FROM_FUND',

  DESELECT_EXCHANGE_TO_FUND = 'DESELECT_EXCHANGE_TO_FUND',
  SELECT_EXCHANGE_TO_FUND = 'SELECT_EXCHANGE_TO_FUND',
  UPDATE_EXCHANGE_TO_FUND = 'UPDATE_EXCHANGE_TO_FUND',
  ADD_NEW_EXCHANGE_TO_FUND = 'ADD_NEW_EXCHANGE_TO_FUND',
  SWAP_NEW_EXCHANGE_TO_FUND = 'SWAP_NEW_EXCHANGE_TO_FUND',

  UPDATE_EXCHANGE_CONTRIBUTION_YEAR = 'UPDATE_EXCHANGE_CONTRIBUTION_YEAR',
  UPDATE_EXCHANGE_FEDERAL_WITHHOLDING = 'UPDATE_EXCHANGE_FEDERAL_WITHHOLDING',
  ACCEPT_RI2020_WITHHOLDING_DISCLOSURE = 'ACCEPT_RI2020_WITHHOLDING_DISCLOSURE',
  ACCEPT_MARKET_FLUCTUATION_DISCLOSURE = 'ACCEPT_MARKET_FLUCTUATION_DISCLOSURE',

  SEARCH_EXCHANGE_TO_EXISTING = 'SEARCH_EXCHANGE_TO_EXISTING',
  SEARCH_EXCHANGE_TO_NEW = 'SEARCH_EXCHANGE_TO_NEW',

  LEAVE_FIRST_SELECTED = 'LEAVE_FIRST_SELECTED',

  UPDATE_MONTH_SELECTION = '@@autoExchange/UPDATE_MONTH_SELECTION',
  UPDATE_DAY_SELECTION = '@@autoExchange/UPDATE_DAY_SELECTION',
  UPDATE_UNIT_SELECTION = 'UPDATE_UNIT_SELECTION',
  UPDATE_GROSS_AMOUNT = 'UPDATE_GROSS_AMOUNT',

  UPDATE_UNIQUE_IDS = 'UPDATE_UNIQUE_IDS',
}
